import type { LocationId } from '@brightlocal/shared';

import {
  CustomerCapabilitiesResponseSchema,
  LocationCapabilitiesResponseSchema,
  SupportedCountriesResponseSchema
} from './schema';
import { HTTP_METHOD } from '../../consts';
import type { ApiCallOptions, Transport } from '../../types';

/** Creates the Capabilities API methods for customer, location and supported-country access. */
export const createCapabilitiesApi = (transport: Transport) => ({
  /** Fetches the capabilities granted to the customer by their plan */
  getCustomerCapabilities: (options?: ApiCallOptions) =>
    transport('/manage/v1/capabilities', {
      method: HTTP_METHOD.GET,
      deserializer: CustomerCapabilitiesResponseSchema,
      signal: options?.signal
    }),

  /** Fetches tool availability and add-on capabilities for a location */
  getLocationCapabilities: (locationId: LocationId, options?: ApiCallOptions) =>
    transport(`/manage/v1/locations/${locationId}/capabilities`, {
      method: HTTP_METHOD.GET,
      deserializer: LocationCapabilitiesResponseSchema,
      signal: options?.signal
    }),

  /** Fetches the countries BrightLocal supports and the tools available in each */
  getSupportedCountries: (options?: ApiCallOptions) =>
    transport('/manage/v1/supported-countries', {
      method: HTTP_METHOD.GET,
      deserializer: SupportedCountriesResponseSchema,
      signal: options?.signal
    })
});

export type CapabilitiesApi = ReturnType<typeof createCapabilitiesApi>;
